import { ApiService } from '@services/api';
import { API_DOMAIN } from '@constants/api';
import {
  IGetCredentialProps,
  ICreateCredentialProps,
  IGenerateURLProps,
  IUpdateCredentialProps,
} from '@domain/interfaces/dashboard/IntegrationCenter/InfoProduct/Platforms/IEvermartAuth';

export class EvermartService {
  private readonly apiService: ApiService;

  constructor(baseURL: string) {
    this.apiService = new ApiService(baseURL);
  }

  public getCredential({ storeAliasId }: IGetCredentialProps): Promise<any> {
    return this.apiService.get(`/api/v1/users/stores/${storeAliasId}/evermart-credentials`);
  }

  public createCredential({ storeAliasId, data }: ICreateCredentialProps): Promise<any> {
    return this.apiService.post(`/api/v1/users/stores/${storeAliasId}/evermart-credentials`, {
      ...data,
    });
  }

  public updateCredential({
    storeAliasId,
    credentialAliasId,
    data,
  }: IUpdateCredentialProps): Promise<any> {
    return this.apiService.put(
      `/api/v1/users/stores/${storeAliasId}/evermart-credentials/${credentialAliasId}`,
      {
        ...data,
      },
    );
  }

  public generateWebhookURL({ storeAliasId }: IGenerateURLProps): Promise<any> {
    return this.apiService.post(
      `/api/v1/users/stores/${storeAliasId}/evermart-credentials/generate-webhook-url`,
    );
  }
}

const evermartService = new EvermartService(API_DOMAIN);

export default evermartService;
